import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { userRegister } from '../../../service/userService';
import MainContext from '../../../context/mainContext';
import { userRegisterValidator } from './../../../service/validatorForms';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { charsNormalize } from '../../../util/charactorsNormalize';
import { getBrowserSession } from '../../../util/fingerPrint';


const LoginPage3 = ({ mobileNumberRef, closeLoginModal, regions }) => {
	const [fullName, setFullName] = useState('');
	const [address, setAddress] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const validatorRef = useRef(userRegisterValidator());
	const [, setForceUpdate] = useState();
	const forceUpdate = useCallback(() => setForceUpdate({}), []);
	const context = useContext(MainContext)
	const textInputRef = useRef(null);
	const navigate = useNavigate();
	const [placeHolderColor, setPlaceHolderColor] = useState('text-muted')
	const [selectedRegion, setSelectedRegion] = useState();

	const submitHandler = async (event) => {
		try {
			event.preventDefault();
			if (validatorRef.current.allValid()) {
				setIsLoading(true);
				const user = {
					name: fullName,
					mobile: mobileNumberRef.current,
					address: address,
					session: JSON.stringify(getBrowserSession()),
					regionId: selectedRegion._id

				}
				const { status, data } = await userRegister(user);
				if (status === 201) {
					localStorage.setItem('token', data.token);
					context.setAppSetting(data.setting);
					context.login({ ...data.user, firstTime: true });
					toast.success('ثبت نام با موفقیت انجام شد')
					closeLoginModal();
					window.innerWidth < 992 && navigate('/account-menu')
				}
			}
			else {
				validatorRef.current.showMessages();
				forceUpdate();
			}

		} catch (err) {
			if (err.response && err.response.status === 422) {
				toast.error("اطلاعات را به طور صحیح وارد کنید")
				setIsLoading(false);
			}
			//بلاک شده
			// else if (err.response && err.response.status === 404) {
			// 	errorMessage('این شماره موبایل قبلا ثبت شده است');
			// 	setIsLoading(false);
			//     validatorRef.current.hideMessageFor('fullName');
			//     validatorRef.current.hideMessageFor('password');
			//     forceUpdate();
			// }
		}
	}

	useEffect(() => {
		textInputRef.current && textInputRef.current.focus();
	}, []);


	return (
		<React.Fragment>
			<form onSubmit={submitHandler} className=" px-3">
				<p className="text-center mb-0 ltr">
					<span className="text-success d-flex align-items-center justify-content-center fs-5">
						<i className="fa fa-check-circle-o text-success fs-5 ms-2">
						</i>
						{mobileNumberRef.current}</span>
				</p>
				<div className="form-floating text-secondary my-1" style={{ fontSize: '.9rem' }} dir='rtl'>
					<input
						type="text"
						autoComplete='off'
						className={`form-control`}
						style={{ fontSize: '.9rem' }}
						id="fullName"
						placeholder="نام و نام خانوادگی"
						value={fullName}
						ref={textInputRef}
						onChange={(e) => setFullName(charsNormalize(e.target.value))}
						onBlur={() => {
							if (fullName !== '') {
								validatorRef.current.showMessageFor("fullName");
								forceUpdate();
							}
						}}
					/>
					{validatorRef.current.message(
						"fullName",
						fullName,
						"required|max:120"
					)}
					<label htmlFor="fullName">نام و نام خانوادگی</label>
				</div>
				<div className="form-floating text-secondary my-2" style={{ fontSize: '.9rem' }} dir='rtl'>
					<select
						className={`form-select  ${placeHolderColor}`}
						id="selectedRegion"
						aria-readonly={false}
						aria-label="Floating label select example"
						value={selectedRegion ? selectedRegion._id : ''}
						onChange={(event) => {
							let findedIndex = regions.findIndex(item => item._id === event.target.value)
							setSelectedRegion(regions[findedIndex]);
						}}
						onFocus={() => setPlaceHolderColor('text-dark')}
						style={{ fontSize: '.9rem' }}
					>
						<option hidden >{selectedRegion ? selectedRegion.name : 'انتخاب کنید ...'}</option>
						{
							regions && regions.map((item) => (
								<option key={item._id} value={item._id} label={item.name} />
							))
						}
					</select>
					{validatorRef.current.message("selectedRegion", selectedRegion, "required")}
					<label htmlFor="selectedRegion">
						شهر / منطقه
					</label>
				</div>
				<div className="form-floating text-secondary my-2" style={{ fontSize: '.9rem' }} dir='rtl'>
					<input
						type="text"
						autoComplete='off'
						className={`form-control`}
						style={{ fontSize: '.9rem' }}
						id="address"
						placeholder="آدرس"
						value={address}
						onChange={(e) => setAddress(charsNormalize(e.target.value))}
						onBlur={() => {
							if (address !== '') {
								validatorRef.current.showMessageFor("address");
								forceUpdate();
							}
						}}
					/>
					{validatorRef.current.message(
						"address",
						address,
						"required|min:15|max:120"
					)}
					<label htmlFor="address" style={{ width: '300px', fontSize: '.7rem' }}
					>آدرس (خیابان - کوچه - پلاک - واحد )</label>
				</div>
				<section className="card-body pt-1">
					<div className="text-center ">
						<button
							type="submit"
							className="btn btn-success w-50 mx-auto d-flex justify-content-center align-items-center"
							disabled={isLoading}
						>
							{
								isLoading &&
								<i className='spinner-border spinner-border-sm operator-button me-2'
								></i>
							}
							تأیید
						</button>
					</div>
				</section>
			</form>
		</React.Fragment>
	);
}

export default LoginPage3;